import React, { useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas';
import styles from './signature.module.scss';
import CTA from '../../../CTA';
import style from '../../pop-up.module.scss';
import { Button } from '@mui/material';
export const Signature = ({setShowModal, receive, date, receiveSignature}) => {
  const sigRef = useRef(null);
  const [signature, setSignature] = useState('')
 const [cedula, setcedula] = useState(null);
  const limpiar = () => {
    sigRef.current.clear();
    setcedula(null)
  };

 
  

  const guardar = () => {
    const canvas = sigRef.current?.getTrimmedCanvas?.();

  
    if (!sigRef.current || sigRef.current.isEmpty() || cedula === null) {
      alert('Por favor firme e ingrese la cedula antes de guardar.');
      return;
    }

      if (cedula.length > 10 || cedula.length < 10) {
       alert('La cedula debe tener 10 dígitos.');
       return;
    }


    if (!canvas) {
      alert('Error: Canvas no disponible.');
      return;
    }

    const imagen = canvas.toDataURL('image/png');
   
    setSignature(imagen)

    receiveSignature(date, imagen, cedula, 'Factura Generada')


  };


   return (
    <>
         <h1 className={style.title}>Firma recibido</h1>
     <div className={styles.firmaContenedor} >
      <SignatureCanvas
        ref={sigRef}
        className={styles.firmaCanvas}
        penColor="black"
        canvasProps={{
          width: 350,
          height: 200,
           
        }}
      />
    
    </div>

      <div>
            <input
                            placeholder="Cedula *"
                            className={`${styles.input}`}
                            onChange={(e) => {
                                setcedula(e.target.value);                               
                            }}
                            value={cedula || ''}
                        />
      </div>    

      <div className={styles.firmaBotones}>
        <Button
        sx={{ textTransform: 'none', boxShadow: 'none', fontFamily:'HK Grotesk', fontSize:'16px' }}
            onClick={limpiar}
            style={{ borderRadius:12 }}
            variant='outlined'
        >Limpiar</Button>
      <Button
      sx={{ textTransform: 'none', boxShadow: 'none',fontSize:'16px' }}
             onClick={guardar}
            style={{ borderRadius:12 }}
            variant='contained'
        >Confirmar </Button>
                 
      </div>
    </>
   
  );
}
